<template>
    <div>
        <h1 v-if="!this.isUpdate" is="sui-header">{{$t('gateway.form.createTitle')}}</h1>
        <sui-grid :columns="2" divided>
            <sui-grid-row>
                <sui-grid-column :width="12">

                    <sui-segment :loading="isLoading">
                        <sui-tab :menu="{ attached: false, tabular: false }" :active-index.sync="activeTabIndex">
                            <sui-tab-pane title="FTP Local" :disabled="isLocalFTPTabDisabled">
                                <LocalFTPForm :isUpdate="isUpdate" :onSubmit="onFormSubmit"/>
                            </sui-tab-pane>

                            <sui-tab-pane title="FTP Externe" :disabled="isExternalFTPTabDisabled">
                                <ExternalFTPForm :onSubmit="onFormSubmit"/>
                            </sui-tab-pane>

                            <sui-tab-pane title="URL" :disabled="isURLTabDisabled">
                                <URLForm :onSubmit="onFormSubmit"/>
                            </sui-tab-pane>

                            <sui-tab-pane title="Proxy" :disabled="isProxyTabDisabled">
                                <ProxyForm :onSubmit="onFormSubmit"/>
                            </sui-tab-pane>
                        </sui-tab>
                    </sui-segment>

                </sui-grid-column>
                <sui-grid-column :width="4" style="position: relative">

                    <MetadataList />

                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
    </div>
</template>

<script>
    import LocalFTPForm from '@/components/gateway/forms/LocalFTPForm.vue';
    import ExternalFTPForm from '@/components/gateway/forms/ExternalFTPForm.vue';
    import ProxyForm from '@/components/gateway/forms/ProxyForm.vue';
    import URLForm from '@/components/gateway/forms/URLForm.vue';
    import MetadataList from '@/components/gateway/MetadataList.vue';
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'GatewayForm',
        components: {
            LocalFTPForm,
            ExternalFTPForm,
            ProxyForm,
            URLForm,
            MetadataList,
        },
        beforeMount() {
            store.commit('setActiveGateway');
        },
        beforeDestroy() {
            store.commit('setActiveGateway');
            store.commit('removeAppTitle');
        },
        data() {
            const isUpdate = !!this.$route.params.gateway_id;
            const title = (isUpdate) ? this.$t('gateway.form.updateTitle') : this.$t('gateway.form.createTitle');

            return {
                activeTabIndexMapping: {
                    LOCAL_FTP: 0,
                    EXTERNAL_FTP: 1,
                    URL: 2,
                    PROXY: 3,
                },
                isLocalFTPTabDisabled: false,
                isExternalFTPTabDisabled: false,
                isProxyTabDisabled: false,
                isURLTabDisabled: false,
                isLoading: false,
                state: store.state,
                gatewayId: this.$route.params.gateway_id,
                isUpdate,
                pageTitle: title,
            }
        },
        computed: {
            ...mapGetters(['activeGateway']),
            activeTabIndex: {
                get() {
                    if (!this.isUpdate) {
                        return 0;
                    }

                    return this.activeTabIndexMapping[this.activeGateway.configuration.fetchMethod];
                },
                set(value) {
                    // if it's an update, can't change tab.
                    if (this.isUpdate) {
                        return;
                    }

                    // otherwise reset the form and set the fetchMethod based on the tab we're on.
                    store.commit('setActiveGateway');

                    this.activeGateway.configuration.fetchMethod = Object.keys(this.activeTabIndexMapping)[value];

                    return;
                }
            },
        },
        async created() {
            this.isLoading = true;

            await store.dispatch('getEncodings');
            await store.dispatch('getMetadatas');

            if (this.isUpdate) {
                await store.dispatch('getGatewayById', this.gatewayId);
                store.commit('setAppTitle', `${this.$t('common.configuration')} - ${this.activeGateway.name}`);
            }
            else {
                store.commit('setAppTitle', `${this.$t('gateway.form.createTitle')}`);
            }

            this.setTabsStates();

            this.isLoading = false;
        },
        methods: {
            async onFormSubmit(e) {
                e.preventDefault();

                const success = await store.dispatch('saveGateway');
                if (success) {
                    this.$toastr.s(this.$t('gateway.form.saveSuccess'));
                }
                else {
                    this.$toastr.e(this.$t('gateway.form.saveError'));
                }
                
                if (success && !this.isUpdate) {
                    this.$router.push({ name: 'GatewaysList' });
                }
            },
            setTabsStates() {
                if (this.isUpdate) {
                    const fetchMethod = this.activeGateway.configuration.fetchMethod;

                    this.isLocalFTPTabDisabled = fetchMethod !== 'LOCAL_FTP';
                    this.isProxyTabDisabled = fetchMethod !== 'PROXY';
                    this.isURLTabDisabled = fetchMethod !== 'URL';
                    this.isExternalFTPTabDisabled = fetchMethod !== 'EXTERNAL_FTP';
                }
            },
        }
    }
</script>

<style>
    .ui.menu .item span {
        font-weight: 600;
        font-size: 18px !important;
    }
</style>
